export const COMPANY_NAME = "MCKEE WELLNESS FOUNDATION";
export const COMPANY_SHORT = "McKee Wellness Foundation";
export const COMPANY_INITIALS = "MWF";
export const COMPANY_ADDRESS_FULL = "1805 E. 18th St. #9, Loveland, CO 80538";
export const COMPANY_LOCATION = "Loveland, CO";
export const COMPANY_REGION = "Larimer County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=1805%20E.%2018th%20St.%20%239%2C%20Loveland%2C%20CO%2080538";
export const HERO_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Focus", "value": "Community Health & Wellness" },
  { "label": "Type", "value": "Colorado Nonprofit Foundation" },
  { "label": "Service Area", "value": "Northern Colorado" },
  { "label": "Location", "value": "Loveland, CO" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "McKee Wellness Foundation" },
  { "label": "City / State", "value": "Loveland, CO" },
  { "label": "Region", "value": "Larimer County" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Community Wellness", "body": "Supports programs that help neighbors across Northern Colorado live healthier, more active lives." },
  { "icon": "✦", "title": "Charitable Giving", "body": "Stewards donor gifts to advance health-focused initiatives in the Loveland community." },
  { "icon": "✿", "title": "Health Education", "body": "Encourages preventive wellness and health awareness through community-centered outreach." },
  { "icon": "❍", "title": "Local Partnership", "body": "Works alongside area organizations to strengthen access to wellness resources." },
];
